<template>
  <div class="comparison">
    <Comparison v-if="canGoToComparisonPage" :items="items"></Comparison>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Comparison from "../components/pages/Comparison";

export default {
  name: "ComparisonView",
  // beforeRouteEnter(to, from, next) {
  //   const isFromTopPage = from.name === "ProductSelect";
  //   isFromTopPage ? next() : next("/");
  // },
  components: {
    Comparison,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      canGoToComparisonPage: false,
    };
  },
  computed: {
    ...mapGetters("product", ["selectedProductIds"]),
  },
  methods: {
    /**
     * アイテムデータが存在し、かつ選択されている場合に正しいアクセスと判別する
     */
    verifyPageAccess() {
      const hasItemData = this.items.length !== 0;
      const hasSelectedIds = this.selectedProductIds.length !== 0;
      const canGoToComparisonPage = hasItemData && hasSelectedIds;
      return canGoToComparisonPage;
    },
  },
  created() {
    if (this.verifyPageAccess()) {
      this.canGoToComparisonPage = true;
    } else {
      this.$router.replace("/");
    }
  },
};
</script>
